// extracted by mini-css-extract-plugin
export default {"cell":"style_cell__XM9JQ"};